export function getActiveEntrances(entrances = []) {
    const list = Array.isArray(entrances) ? entrances : (entrances ? [entrances] : []);
    return list.filter((entrance) => entrance && entrance.isDeleted !== true && entrance.isDisabled !== true);
}

export function resolveExitSelection({ sameAsCheckIn, selectedId, checkInEntranceId, entrances }) {
    const active = getActiveEntrances(entrances);
    if (!active.length) {
        return { exitEntranceId: null, needsPick: false, skipStep: true };
    }
    if (active.length === 1) {
        return { exitEntranceId: active[0].id, needsPick: false, skipStep: true, autoName: active[0].name };
    }
    if (sameAsCheckIn) {
        return {
            exitEntranceId: checkInEntranceId || active[0].id,
            needsPick: false,
            skipStep: false,
            sameAsCheckIn: true,
        };
    }
    if (active.length === 2) {
        const other = active.find((entrance) => entrance.id !== checkInEntranceId) || active[0];
        return { exitEntranceId: other.id, needsPick: false, skipStep: false, autoName: other.name };
    }
    if (!selectedId) {
        return { exitEntranceId: null, needsPick: true, skipStep: false };
    }
    return { exitEntranceId: Number(selectedId), needsPick: false, skipStep: false };
}

export function getCheckInEntranceName(booking) {
    return booking?.checkInEntrance?.name || booking?.displayEntrance?.name || '';
}
